import React, { useContext } from 'react';
import { translatableText } from '../../utils/translatable-text';
//@ts-ignore
import { CardGroup, Card } from '../card';
import CurrentContextIdContext from '../../contexts/current-context-id-context';
import camelCase from 'lodash/camelCase';
import { AtlasLink } from '../atlas-link';
import {
    hardcodedAppAndThemeReferences,
    hardcodedJiraContexts,
    hardcodedHubReferences
} from './hardcoded-refs';
import { getHardcodedReferences } from './get-hardcoded-refs';

interface AppAndThemeCards {
    title: string;
    url: string;
    description: string;
    id: string;
}

const MAX_FULL_CARDS = 5;
// eslint-disable-next-line complexity
export const addStaticCards = (
    relatedLinks: AppAndThemeCards[] | undefined,
    contextId: string,
    isHardcodedAtlassianCloudHelpfulLinksEnabled: boolean | undefined,
    isHardcodedOpsgenieHelpfulLinksEnabled: boolean | undefined,
    isCloudAutomationEnabled: boolean | undefined
    // eslint-disable-next-line max-params
) => {
    const { developersLink, trainingLink, marketplaceAppLink } =
        hardcodedAppAndThemeReferences;

    if (!relatedLinks) {
        relatedLinks = [];
    }
    let relatedReferences = [...relatedLinks];

    if (
        isHardcodedAtlassianCloudHelpfulLinksEnabled ||
        isHardcodedOpsgenieHelpfulLinksEnabled
    ) {
        const hardcodedReferences = getHardcodedReferences(
            contextId,
            isHardcodedAtlassianCloudHelpfulLinksEnabled,
            isHardcodedOpsgenieHelpfulLinksEnabled,
            isCloudAutomationEnabled
        );
        relatedReferences = hardcodedReferences.length
            ? hardcodedReferences
            : relatedReferences;
    }

    relatedReferences = [
        ...relatedReferences,
        marketplaceAppLink,
        developersLink,
        trainingLink
    ];

    // if FF hasn't been turned on yet, prepend Jira Cloud Admin to links.
    if (!isHardcodedAtlassianCloudHelpfulLinksEnabled) {
        if (hardcodedJiraContexts.includes(contextId)) {
            relatedReferences = [
                hardcodedHubReferences.jiraCloudAdmin,
                ...relatedReferences
            ];
        }
    }

    return relatedReferences;
};

export const HelpfulTopics = ({
    relatedAppReferences,
    isHardcodedAtlassianCloudHelpfulLinksEnabled,
    isHardcodedOpsgenieHelpfulLinksEnabled,
    isCloudAutomationEnabled
}: {
    relatedAppReferences: AppAndThemeCards[] | undefined;
    isHardcodedAtlassianCloudHelpfulLinksEnabled: boolean | undefined;
    isHardcodedOpsgenieHelpfulLinksEnabled: boolean | undefined;
    isCloudAutomationEnabled: boolean | undefined;
}) => {
    const contextId = useContext(CurrentContextIdContext);
    const linksToRender = addStaticCards(
        relatedAppReferences,
        contextId,
        isHardcodedAtlassianCloudHelpfulLinksEnabled,
        isHardcodedOpsgenieHelpfulLinksEnabled,
        isCloudAutomationEnabled
    );
    const showCards = linksToRender.length <= MAX_FULL_CARDS;

    return (
        <div className={'helpful-topics__container'}>
            <h3 className="ternary-heading helpful-topics__title">
                {translatableText.helpfulTopics.text}
            </h3>
            {showCards && (
                <CardGroup className={'documentation-dropdown'}>
                    {linksToRender.map(({ title, url, description, id }) => (
                        <Card
                            title={title}
                            buttonLink={url}
                            className={'documentation-card'}
                            description={description}
                            key={id}
                            type={'full'}
                        />
                    ))}
                </CardGroup>
            )}
            {!showCards && (
                <div className="dropdown__card-styling">
                    <ul className="nav-links__list single-line">
                        {linksToRender.map(({ title, url, id }) => (
                            <li
                                data-testid="dropdown_item"
                                className="nav-links__item"
                                key={id}
                            >
                                <AtlasLink
                                    href={url}
                                    text={title}
                                    dataName={camelCase(title)}
                                >
                                    <span>{title}</span>
                                </AtlasLink>
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
};
